import React from 'react';
import { playModes, useAudioPlayerStore } from '@/state/audio-player-store';

export const PlayModeButton = () => {
  const { playMode, setPlayMode } = useAudioPlayerStore();
  const renderPlayMode = () => {
    switch (playMode) {
      case 'ONCE':
        return <a title="once">ONCE</a>;
      case 'REPEAT':
        return <a title="repeat">REPEAT</a>;
      case 'CYCLE':
        return <a title="cycle">CYCLE</a>;
    }
  };
  return (
    <div
      onClick={() => {
        const currentIndex = playModes.indexOf(playMode);
        const nextIndex = (currentIndex + 1) % playModes.length;
        setPlayMode(playModes[nextIndex]);
      }}
    >
      {renderPlayMode()}
    </div>
  );
};
